export default {
  data: () =>({
    collapsedPromotions: {},
  }),
  methods: {
    collapsePromo(brandId, menuItemId) {
      const isCollapse = this.collapsedPromotions[`${brandId}-${menuItemId}`] == undefined ? false :
      !this.collapsedPromotions[`${brandId}-${menuItemId}`];

      this.$set(this.collapsedPromotions, `${brandId}-${menuItemId}`, isCollapse);
    },
    isCollapse(brandId, menuItemId) {
      const promoCollapseItem = this.collapsedPromotions[`${brandId}-${menuItemId}`];

      if(promoCollapseItem == undefined) return true;

      return promoCollapseItem;
    }
  }
}
